import React from "react";

const WhyTrust = () => {
    return (
        <section className="section why-trust-section">
            <div className="container">
                <div className="section-title text-center mb-5">
                    <h2>Why growing companies trust <span className="text-theme">Syncuppro</span></h2>
                </div>

                <div className="row">
                    <div className="col-md-6 col-lg-4 mb-4">
                        <div className="trust-block text-center">
                            <img className="mb-3" src="images/post-requ.svg" alt="speed" />
                            <h6 className="mb-3">Speed</h6>
                            <p className="mb-0" style={{ fontSize: '18px' }}>Start working with qualified compliance experts in days, not months, without sales cycles, proposals, or delays.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-4">
                        <div className="trust-block text-center">
                            <img className="mb-3" src="images/best-experts.svg" alt="quality" />
                            <h6 className="mb-3">Quality</h6>
                            <p className="mb-0" style={{ fontSize: '18px' }}>Every professional is vetted before joining the platform, reducing audit risk, rework, and costly mistakes.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-4">
                        <div className="trust-block text-center">
                            <img className="mb-3" src="images/multiple-proposal.svg" alt="cost-efficiency" />
                            <h6 className="mb-3">Cost efficiency</h6>
                            <p className="mb-0" style={{ fontSize: '18px' }}>Pay for the compliance expertise you need at freelancer-level pricing instead of bundled consulting firm fees.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-4">
                        <div className="trust-block text-center">
                            <img className="mb-3" src="images/compliance-experts-profiles.svg" alt="simplicity" />
                            <h6 className="mb-3">Simplicity</h6>
                            <p className="mb-0" style={{ fontSize: '18px' }}>Find consultants, auditors, certification bodies, and training providers in one place, without managing multiple vendors.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-4">
                        <div className="trust-block text-center">
                            <img className="mb-3" src="images/project-tracking.svg" alt="flexibility" />
                            <h6 className="mb-3">Flexibility</h6>
                            <p className="mb-0" style={{ fontSize: '18px' }}>Engage support based on your needs and timeline without being locked into a fixed methodology or contract.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-4">
                        <div className="trust-block text-center">
                            <img className="mb-3" src="images/get-hiried.svg" alt="cultural-fit" />
                            <h6 className="mb-3">Cultural fit</h6>
                            <p className="mb-0" style={{ fontSize: '18px' }}>Choose who you work with based on experience and fit, not whoever a firm assigns to your account.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyTrust;